import { EventHub } from "@/constants/constants"
import { mapActions } from 'vuex'
import { DialogGPS } from "@/tools/dialog"
import { gpsService } from "../../../../../services/gps.service"
import AutocompleteComponent from "@/components/commons/autocomplete/AutocompleteComponent.vue";

export default {
    name: 'GpsTabComponent',
    components: {
        AutocompleteComponent
    },
    model: {
        prop: 'model',
        event: 'change'
    },
    props: {
        model: {
            type: Object,
            required: true
        },
        validationRules: {
            type: Object,
            required: true
        },
        validForm: {
            type: Boolean,
            required: true
        },
        resetFormValidation: {
            type: Boolean,
            required: true
        }
    },
    data: () => ({
        // selector de gps
        gps: [],
        // loading
        loadingGps: false,
        isValidForm: false,
        lineCarrier: null,
        lineNumber: null,
        gpsBrand: null,
        gpsModel: null,
        simCard: null,
    }),
    computed: {
    },
    created () {
        // Evento lanzado por el diálogo de creación de gps, cuando se guarda el nuevo gps
        this.$eventBus.$on(EventHub.COMMIT_GPS, (gpsDto) => {
            this.getGps(gpsDto._id)
        })
    },
    beforeDestroy() {
        // desuscripción al bus de eventos
        this.$eventBus.$off(EventHub.COMMIT_GPS)
    },
    mounted () {
        this.getGps()
    },
    methods: {
        /**
         * actions del breadcrumb
         */
        ...mapActions('breadcrumbs', [
            'pushBread'
        ]),
        /**
         * Obtener todos los gps
         * @param gpsId id del gps creado
         */
        async getGps(gpsId) {
            this.loadingGps = true
            this.gps = await gpsService.getAllForSelectorThingAbm()
            if (gpsId != null) {
                this.model.gpsId = gpsId
            }
            this.loadingGps = false
        },
        /**
         * Carga el dialogo para crear un gps
         */
        openGps() {
            const bread = {
                key: DialogGPS,
                disabled: true,
                text: this.$t('gps.name')
            }
            this.pushBread(bread)
        },
        /**
         * Obtener información de un GPS
         */
        getGpsDataById(gpsId) {
            if(gpsId){
            gpsService.getForThingABM(gpsId).then(response => {
                if (response) {
                    this.lineCarrier = response.lineCarrier1
                    this.lineNumber = response.lineNumber1
                    this.gpsBrand = response.brand
                    this.gpsModel = response.model
                    this.simCard = response.simCard1
                }
            });
            }
        },
        /**
         * Cada vez que se modifica la selección del gps, se cargan
         */
        gpsSelectedFunction (newValue) {
            if(newValue == null){
                this.model.gpsId = null;
                this.lineCarrier = null;
                this.lineNumber = null;
                this.gpsBrand = null;
                this.gpsModel = null;
                this.simCard = null;
            } else {
                this.model.gpsId = newValue._id ? newValue._id : newValue;
            }
        },
    },
    watch: {
        /**
         * Para restablecer las validaciones del formulario
         * @param {*} newVal
         */
        resetFormValidation(newVal) {
            if (newVal && this.$refs.gpsTabForm) {
                this.$refs.gpsTabForm.resetValidation()
            }
        },
        isValidForm(newVal, oldVal){
            if(newVal !== oldVal){
                this.$emit('update:validForm', newVal)
            }
        },
        'model.gpsId':{
            deep: true,
            immediate: true,
            handler: function (newGpsId) {
                if (newGpsId) {
                    this.getGpsDataById(newGpsId)
                }
            }
        },
    }
}
